import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Slider,
  Grid,
  Paper,
  CircularProgress,
  Button,
  Hidden,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useQuery, useLazyQuery, gql, useMutation } from "@apollo/client";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

// Sub Components

import store from "../../../../redux/store";
import { actions } from "../../Auth/_redux/authRedux";
import { GET_OCCUPATION, GET_JOBS } from "../_redux/dashboardCrud";

import axios from 'axios';

const SAVE_OCCUPATION = gql`
  mutation SaveOccupation(
    $saveOccupationOccupationId: String!
    $saveOccupationBlsIndustryId: String!
  ) {
    saveOccupation(
      occupationId: $saveOccupationOccupationId
      blsIndustryId: $saveOccupationBlsIndustryId
    ) {
      success
    }
  }
`;

const useStyles = makeStyles({
  root: {
    background: "white",
    position: "sticky",
    top: 20,
    bottom: 20,
    paddingTop: "40px",
    paddingBottom: "40px",
    zIndex: 5,
  },
});

export function OccupationDetails(props) {
  const indId = props.match.params.industryId;

  const history = useHistory();
  const classes = useStyles();
  const { id: occupationId, industryId: blsIndustryId } = useParams();

  const [getJobs] = useLazyQuery(GET_JOBS, {
    onCompleted: (data) => {
      setJobs(data.zipJobList.jobs);
    },
  });

  const { user } = useSelector((state) => state.auth);

  const [jobs, setJobs] = useState([]);

  const [saveOccupation, { loading: saveOccupationLoading }] = useMutation(
    SAVE_OCCUPATION,
    {
      onCompleted() {
        store.dispatch(
          actions.addSavedOccupation({ occupationId, blsIndustryId })
        );
      },
    }
  );

  const scrollToRef = (ref) =>
    window.scrollTo({ top: ref.current.offsetTop - 80, behavior: "smooth" });

  const { data, loading } = useQuery(GET_OCCUPATION, {
    variables: {
      getOccupationOccupationId: occupationId,
      getOccupationBlsIndustryId: blsIndustryId,
    },
    onCompleted: () => {
      getJobs({
        variables: {
          zipJobListSearch:
            data.getOccupation.occupation.title +
            " " +
            data.getOccupation.occupation.jobTitleSamples.join(" "),
          zipJobListLocation: "New York",
          zipJobListRadiusMiles: 100,
          zipJobListDaysAgo: 5,
          zipJobListJobsPerPage: 5,
          zipJobListPage: 1,
        },
      });
    },
  });

  const {
    auth: { tokenExpiresAt },
  } = store.getState();
  if (moment().isAfter(moment(tokenExpiresAt))) {
    localStorage.clear();
  }

  const isSaved =
    user &&
    user.savedOccupations &&
    user.savedOccupations.find(
      (o) =>
        o.occupationId === occupationId && o.blsIndustryId === blsIndustryId
    );

  const PrettoSlider = withStyles({
    root: {
      color: "#01a9f4",
      height: 8,
    },
    thumb: {
      height: 18,
      width: 18,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      marginTop: -5,
      marginLeft: -12,
      "&:focus, &:hover, &$active": {
        boxShadow: "inherit",
      },
    },
    active: {},
    valueLabel: {
      left: "calc(-50% + 4px)",
    },
    track: {
      height: 8,
      borderRadius: 4,
    },
    rail: {
      height: 8,
      borderRadius: 4,
    },
  })(Slider);

  const [pageOverViewFocus, setPageOverViewFocus] = useState("whatTheyDo");
  const whatTheyDoRef = useRef(null);
  const whatContextRef = useRef(null);
  const onTheJobTaskRef = useRef(null);
  const educationRef = useRef(null);
  const workActivitiesRef = useRef(null);
  const detailedWorkActivitiesRef = useRef(null);
  const skillsRef = useRef(null);
  const abilitiesRef = useRef(null);
  let averageSalary = "";
  if (data) {
    data.getOccupation.blsSeriesList.forEach((blsSeries) => {
      if (blsSeries.seriesId.slice(23) === "13") {
        averageSalary = blsSeries.value;
      }
    });
  }

  const [training, setTraining] = useState([]);
  const [pending, setPending] = useState(false);


  useEffect(()=>{
    if(!pending && training.length == 0 && occupationId){
      let id = occupationId.split(".")[0];
      fetchTraining(id)
    }
  }, [occupationId])

  const fetchTraining = async (id) => {
    setPending(true);
    try{
      let res = await axios.get(`https://roshi-chat.herokuapp.com/career/traning?code=${id}`);
      // console.log(res);
      if(res.data.traning){
        setTraining(res.data.traning)
      }

    }catch(ex){
      console.error(ex);
    }finally{
      setPending(false);
    }
  }

  // useEffect(()=>{
  //   console.log(training);
  // }, [training])


  return (
    <Box
      display="flcolumn"
      alignItems="center"
      style={{ backgroundColor: "white" }}
      px={2}
    >
      <Box width="100%">
        {loading ? (
          <Box p={5} textAlign="center">
            <CircularProgress style={{ color: "#3699FF" }} />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" mt={2} flexWrap="wrap">
            <Grid container>
              <Grid item xs={12}>
                <Paper>
                  <Box p={4}>
                    <Box
                      display="flex"
                      alignItems="center"
                      ml={5}
                      flexWrap="wrap"
                    >
                      <Typography variant="h2">
                        {data.getOccupation.occupation.title}
                      </Typography>
                      <Box ml={4}>
                        <Button
                          variant="contained"
                          style={{ color: "#3699FF", borderColor: "#3699FF" }}
                          disabled={!user || isSaved}
                          onClick={() => {
                            saveOccupation({
                              variables: {
                                saveOccupationOccupationId: occupationId,
                                saveOccupationBlsIndustryId: blsIndustryId,
                              },
                            });
                          }}
                        >
                          {isSaved ? (
                            "Saved"
                          ) : saveOccupationLoading ? (
                            <CircularProgress
                              style={{ color: "#3699FF" }}
                              color="secondary"
                              size={20}
                            />
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </Box>
                    </Box>
                    <Box display="flex" m={2} alignItems="center">
                      <Box mr={2}>
                        <img
                          width={100}
                          height={100}
                          src={"/media/icons/service.png"}
                          alt="occupation"
                        />
                      </Box>
                      <Grid container>
                        <Grid item xs={12} md={4}>
                          {data.getOccupation.occupation.pathway && (
                            <Typography variant="h5">
                              A member of{" "}
                              {data.getOccupation.occupation.pathway.title}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box display="flex" flexDirection="column">
                            <Typography variant="subtitle1">
                              Also known as:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: 15 }}
                            >
                              {data.getOccupation.occupation.jobTitleSamples.join(
                                ", "
                              )}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box display="flex" flexDirection="column">
                      <Grid
                        container
                        direction="row"
                        className="mt-3 "
                        spacing={2}
                        justify="center"
                      >
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              history.push("/");

                              return false;
                            }}
                          >
                            Back to search
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              history.push("/industry/" + indId);

                              return false;
                            }}
                          >
                            Back to Industry
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Box m={5} boxShadow={5}>
                  <Box display="flex" flexDirection="column" p={3}>
                    <Typography variant="h5">Job Outlook</Typography>
                    <Box
                      flexGrow={1}
                      height={3}
                      width="6%"
                      style={{ backgroundColor: "#01a9f4" }}
                      my={1}
                    ></Box>
                    <Grid container spacing={3}>
                      {data.getOccupation.occupation.projectedOpenings && (
                        <Grid item xs={6} md={2}>
                          <Box mb={2}>
                            <Box mb={1}>
                              <Typography>Total Annual Openings</Typography>
                            </Box>
                            <Typography variant="h5">
                              {data.getOccupation.occupation.projectedOpenings}
                            </Typography>
                            <PrettoSlider
                              valueLabelDisplay="auto"
                              value={[10, 30]}
                            />
                          </Box>
                        </Grid>
                      )}
                      {(data.getOccupation.occupation.projectedGrowth ||
                        data.getOccupation.occupation
                          .projectedGrowthPercent) && (
                        <Grid item xs={6} md={2}>
                          <Box mb={2}>
                            <Box mb={1}>
                              <Typography>Total Projected Growth</Typography>
                            </Box>
                            <Typography variant="h5">
                              {data.getOccupation.occupation
                                .projectedGrowthPercent +
                                "% - " +
                                data.getOccupation.occupation.projectedGrowth}
                            </Typography>
                            <PrettoSlider
                              valueLabelDisplay="auto"
                              value={[10, 30]}
                            />
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs={6} md={2}>
                        <Box mb={2}>
                          <Box mb={1}>
                            <Typography>Average Salary</Typography>
                          </Box>
                          <Typography variant="h5">${averageSalary}</Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={2}>
                        <Box mb={2}>
                          <Box mb={1}>
                            <Typography>Job Zone</Typography>
                          </Box>
                          <Typography variant="h5">
                            {data.getOccupation.occupation.jobZoneId || "N/A"}
                          </Typography>
                          <Typography>
                            Job zone {data.getOccupation.occupation.jobZoneId}:
                            considerable preparation needed
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Box mb={2}>
                          <Typography>Save this Job</Typography>
                          <Box mt={2}>
                            <Button
                              variant="contained"
                              style={{
                                color: "#3699FF",
                                borderColor: "#3699FF",
                              }}
                              disabled={!user || isSaved}
                              onClick={() => {
                                saveOccupation({
                                  variables: {
                                    saveOccupationOccupationId: occupationId,
                                    saveOccupationBlsIndustryId: blsIndustryId,
                                  },
                                });
                              }}
                            >
                              {isSaved ? (
                                "Saved"
                              ) : saveOccupationLoading ? (
                                <CircularProgress
                                  style={{ color: "#3699FF" }}
                                  color="secondary"
                                  size={20}
                                />
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={10}>
                <Box m={2}>
                  <Box mb={3} ref={whatTheyDoRef}>
                    <Typography variant="h4">What they Do</Typography>
                    <Box
                      flexGrow={1}
                      height={3}
                      width="10%"
                      style={{ backgroundColor: "#01a9f4" }}
                      my={1}
                      mb={3}
                    ></Box>
                    <Typography variant="subtitle1" style={{ fontSize: 15 }}>
                      {data.getOccupation.occupation.description}
                    </Typography>
                  </Box>
                  {data.getOccupation.occupation.workContexts.length ? (
                    <Box mb={3} id="whatContext" ref={whatContextRef}>
                      <Typography variant="h4">What Context</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      {data.getOccupation.occupation.workContexts
                        .filter((context) => context.score.important)
                        .map((context) => (
                          <Box mb={3} key={context.id}>
                            <Typography variant="h6">{context.name}</Typography>
                            <Typography style={{ fontSize: 14 }}>
                              {context.description}{" "}
                              <b>
                                {context.response.map((response, index) => {
                                  if (context.response.length === index - 1)
                                    return (
                                      response.percentage +
                                      "% responded " +
                                      response.name
                                    );
                                  else
                                    return (
                                      response.percentage +
                                      "% responded " +
                                      response.name +
                                      ", "
                                    );
                                })}
                              </b>
                            </Typography>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.tasks.length ? (
                    <Box mb={3} id="onTheJobTask" ref={onTheJobTaskRef}>
                      <Typography variant="h4">On The Job Task</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      <ul>
                        {data.getOccupation.occupation.tasks.map((activity) => (
                          <li style={{ marginBottom: 15 }} key={activity.id}>
                            <Typography
                              variant="subtitle1"
                              style={{ fontSize: 15 }}
                            >
                              {activity.statement}
                            </Typography>
                          </li>
                        ))}
                      </ul>
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.education.length ||
                  data.getOccupation.occupation.jobZone ? (
                    <Box mb={3} id="education" ref={educationRef}>
                      <Typography variant="h4">Education</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      <Box>
                        <Box>
                          <Typography variant="h5">
                            {data.getOccupation.occupation.jobZone.education}
                          </Typography>
                        </Box>
                        {data.getOccupation.occupation.education.length ? (
                          <Box>
                            <Typography variant="h5" style={{ fontWeight: 50 }}>
                              Requirements:
                            </Typography>
                            <Box mt={2}>
                              <ul>
                                {data.getOccupation.occupation.education.map(
                                  (requirement) => (
                                    <li key={requirement.name}>
                                      <Box mb={2}>
                                        <Typography variant="h5">
                                          {requirement.name}
                                        </Typography>
                                        {requirement.description && (
                                          <Typography>
                                            {requirement.description}
                                          </Typography>
                                        )}
                                        {requirement.score && (
                                          <Typography variant="caption">
                                            {requirement.score.value}% of
                                            respondents surveyed claimed this
                                            was a requirement.
                                          </Typography>
                                        )}
                                      </Box>
                                    </li>
                                  )
                                )}
                              </ul>
                            </Box>
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.workActivities.length ? (
                    <Box mb={3} id="workActivities" ref={workActivitiesRef}>
                      <Typography variant="h4">Work activities</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      {data.getOccupation.occupation.workActivities
                        .filter((workActivity) => workActivity.score.important)
                        .map((workActivity) => (
                          <Box mb={3} key={workActivity.id}>
                            <Typography variant="h6">
                              {workActivity.name}
                            </Typography>
                            <Typography style={{ fontSize: 15 }}>
                              {workActivity.description}
                            </Typography>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.detailedWorkActivities
                    .length ? (
                    <Box
                      mb={3}
                      id="detailedWorkActivities"
                      ref={detailedWorkActivitiesRef}
                    >
                      <Typography variant="h4">
                        Detailed Work Activities
                      </Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      <ul>
                        {data.getOccupation.occupation.detailedWorkActivities.map(
                          (activity) => (
                            <li style={{ marginBottom: 15 }} key={activity.id}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontSize: 15 }}
                              >
                                {activity.name}
                              </Typography>
                            </li>
                          )
                        )}
                      </ul>
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.skills.length ? (
                    <Box mb={3} id="skills" ref={skillsRef}>
                      <Typography variant="h4">Skills</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      {data.getOccupation.occupation.skills
                        .filter((skill) => skill.score.important)
                        .map((skill) => (
                          <Box mb={3} key={skill.id}>
                            <Typography variant="h6">{skill.name}</Typography>
                            <Typography style={{ fontSize: 15 }}>
                              {skill.description}
                            </Typography>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    ""
                  )}
                  {data.getOccupation.occupation.abilities.length ? (
                    <Box mb={3} id="abilities" ref={abilitiesRef}>
                      <Typography variant="h4">Abilities</Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="10%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                      {data.getOccupation.occupation.abilities
                        .filter((ability) => ability.score.important)
                        .map((ability) => (
                          <Box mb={3} key={ability.id}>
                            <Typography variant="h6">{ability.name}</Typography>
                            <Typography>{ability.description}</Typography>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Grid>
              <Hidden only="xs">
                <Grid item xs={false} sm={3} md={2}>
                  <Box className={classes.root}>
                    <Box pt={1}>
                      <Typography variant="h6">
                        <strong>Page Overview</strong>
                      </Typography>
                    </Box>
                    {
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("whatTheyDo");
                          scrollToRef(whatTheyDoRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "whatTheyDo"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>What they Do</strong>
                        </Typography>
                      </Box>
                    }
                    {data.getOccupation.occupation.workContexts.length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("whatContext");
                          scrollToRef(whatContextRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "whatContext"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>What Context</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}{" "}
                    {data.getOccupation.occupation.tasks.length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("onTheJobTask");
                          scrollToRef(onTheJobTaskRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "onTheJobTask"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>On the Job Task</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    {data.getOccupation.occupation.education.length ||
                    data.getOccupation.occupation.jobZone ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("education");
                          scrollToRef(educationRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "education"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>Education</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    {data.getOccupation.occupation.workActivities.length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("workActivities");
                          scrollToRef(workActivitiesRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "workActivities"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>Work Activities</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    {data.getOccupation.occupation.detailedWorkActivities
                      .length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("detailedWorkActivities");
                          scrollToRef(detailedWorkActivitiesRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "detailedWorkActivities"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>Detailed Work Activities</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    {data.getOccupation.occupation.skills.length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("skills");
                          scrollToRef(skillsRef);
                          // skillsRef.current.scrollIntoView({
                          //   behavior: "smooth",
                          // });
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "skills"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>Skills</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    {data.getOccupation.occupation.abilities.length ? (
                      <Box
                        mr={2}
                        my={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPageOverViewFocus("abilities");
                          scrollToRef(abilitiesRef);
                        }}
                      >
                        <Typography
                          style={
                            pageOverViewFocus === "abilities"
                              ? {}
                              : { color: "grey" }
                          }
                        >
                          <strong>Abilities</strong>
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                  </Box>
                  <Box>
                    <Box pt={1}>
                      <Typography variant="h6">
                        <strong>Career Training</strong>
                      </Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="15%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                    </Box>
                    <Box mr={2} my={2} style={{ cursor: "pointer" }}>
                      {pending 
                        && 
                      <Typography>
                        <strong>Please wait ...</strong>
                      </Typography>}
                      {!pending && training.length == 0 && <>
                        <Typography>
                          <strong>No programs available.</strong>
                        </Typography>
                      </>}
                      {!pending && training.length > 0 && training.map(obj => {
                        return <>
                          <Typography>
                            { obj.Title }
                          </Typography>
                        </>
                      })}
                      
                    </Box>
                  </Box>
                  <Box>
                    <Box pt={1}>
                      <Typography variant="h6">
                        <strong>Colleges</strong>
                      </Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="15%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                    </Box>
                    <Box mr={2} my={2} style={{ cursor: "pointer" }}>
                      <Typography>
                        <strong>Display Coming Soon</strong>
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Box pt={1}>
                      <Typography variant="h6">
                        <strong>Jobs</strong>
                      </Typography>
                      <Box
                        flexGrow={1}
                        height={3}
                        width="15%"
                        style={{ backgroundColor: "#01a9f4" }}
                        my={1}
                        mb={3}
                      ></Box>
                    </Box>
                    <Box mr={2} my={2} style={{ cursor: "pointer" }}>
                      {jobs.map((job) => (
                        <Box
                          key={job.id}
                          mb={1}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            window.open(
                              `${process.env.REACT_APP_JOB_BOARD_DASH_URL}/#/dashboard?apply=${data.getOccupation.occupation.title}`
                            );
                          }}
                        >
                          <Typography color="secondary">{job.name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
              </Hidden>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
}
